import React, { useEffect, useState } from 'react';
import {
    List,
    ListItemButton,
    ListItemText,
    Typography,
    Box,
} from '@mui/material';
import { Link } from 'react-router-dom';

import services from 'src/services/Services';
import UserService from 'src/services/UserService';
import InstanceDataUser from 'src/services/InstanceDataUser';
import MenuRoles from 'src/utils/MenuRoles';

const camelize = (text = "") =>
    text
        .replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
        .replace(/^./, (c) => c.toUpperCase());

const OptionMenu = () => {
    const [modules, setModules] = useState([]);
    const [roleName, setRoleName] = useState("");

    useEffect(() => {
        const loadMenu = async () => {
            try {

                const roleResp = await services.getRoleById(UserService.getUserID());
                const { id, name } = roleResp.data[0];

                InstanceDataUser.setRol(name);
                setRoleName(name);

                // 2️⃣ Módulos del rol
                const attrResp = await services.getAttributesRoles(id);
                const { exportacion, precio, modulos } = attrResp.data.attributes;

                InstanceDataUser.setAttributes(
                    exportacion?.[0] ?? false,
                    precio?.[0] ?? false
                );

                const ORDER = [
                    "roles",
                    "usuarios",
                    "tokens",
                    "existencias",
                    "pedidos",
                    "pedidosInternos",
                ];

                const filteredModules = (modulos || []).filter((m) =>
                    ORDER.includes(m)
                );

                filteredModules.sort(
                    (a, b) => ORDER.indexOf(a) - ORDER.indexOf(b)
                );

                setModules(filteredModules);
            } catch (error) {
                console.error("Error construyendo menú:", error);
            }
        };

        loadMenu();
    }, []);

    return (
        <Box sx={{ mt: 2 }}>
            {/* ROL */}
            <Typography
                variant="caption"
                sx={{ color: "rgba(255,255,255,0.7)", px: 2, mb: 1, display: "block" }}
            >
                Rol: {camelize(roleName)}
            </Typography>

            {/* MENÚ */}
            <List>
                {modules.map((option) => (
                    <ListItemButton
                        key={option}
                        component={Link}
                        to={MenuRoles.menu[option]}
                        sx={{
                            color: "white",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.1)",
                            },
                        }}
                    >
                        <ListItemText primary={camelize(option)} />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );
};

export default OptionMenu;
